import {
  CHAT_MESSAGE_FEEDBACK_ENDPOINT,
  CHAT_THREAD_FEEDBACK_ENDPOINT,
} from 'api/constants';
import { api } from 'store/api/api';

type CreateMessageFeedbackArgs = {
  messageId: string;
  isLiked: boolean;
};

type CreateThreadFeedbackArgs = {
  threadId: string;
  isHelpful: boolean;
  comment: string | null;
};

const chatFeedbackApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createMessageFeedback: builder.mutation<void, CreateMessageFeedbackArgs>({
      query: ({ messageId, isLiked }) => ({
        url: CHAT_MESSAGE_FEEDBACK_ENDPOINT.replace(':messageId', messageId),
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: { is_liked: isLiked },
        credentials: 'include',
      }),
    }),

    createThreadFeedback: builder.mutation<void, CreateThreadFeedbackArgs>({
      query: ({ threadId, isHelpful, comment }) => ({
        url: CHAT_THREAD_FEEDBACK_ENDPOINT.replace(':threadId', threadId),
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: { is_helpful: isHelpful, comment },
        credentials: 'include',
      }),
    }),
  }),
});

export const {
  useCreateMessageFeedbackMutation,
  useCreateThreadFeedbackMutation,
} = chatFeedbackApi;
